import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class CorporateEmailInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'CorporateEmail',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.userInformation.email
  }
}
